<template>
  <PageOverlay v-if="isLoading" />
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
import PageOverlay from "@/components/PageOverlay";
import NewConversationForm from "@/components/conversations/NewConversationForm";

export default {
  name: "TokenLoader",
  components: { PageOverlay },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["agencySettings"]),
    ...mapGetters("conversations", ["activeConversations"]),
  },
  methods: {
    async loadRsosToken(token) {
      try {
        this.isLoading = true;
        const resp = await this.$ConveyApi.recipientsApi.importRecipientFromExternalProvider({
          payload: { provider_token: token }
        });
        this.$store.commit("provider/setProviderImport", resp.data.data);
        this.$cookie.delete("x-rsos-token");
        this.$toastr("success", "Provider recipient imported!");

        const { number } = resp.data.data;
        const conversation = this.activeConversations.find(convo => {
          const { recipients } = convo;
          if (recipients.length > 0) {
            return recipients[0].number === number;
          }
          return false;
        });

        if (conversation) {
          this.$router.push({
            name: "Conversation Detail",
            params: { conversationId: conversation.conversation_id },
          });
        } else {
          setTimeout(() => {
            this.openNewConversationForm();
          }, 500);
        }
      } catch(err) {
        this.$cookie.delete("x-rsos-token");
        console.log("Token load error: " + err);
      } finally {
        this.isLoading = false;
      }
    },
    openNewConversationForm() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: NewConversationForm,
        title: "New Conversation",
        actionButton: "Start Conversation",
        closeOnClick: true,
      });
    }
  },
  created() {
    const rsosToken = this.$cookie.get("x-rsos-token");
    if (rsosToken && this.agencySettings['core:communicatorEnabled']) {
      this.loadRsosToken(rsosToken);
    }
  }
};
</script>
